import { CommonButton } from 'components/Button'
import { Font14 } from 'components/Typography/Labels'
import styled from 'styled-components'
import theme from 'theme_'

export const SubscriptionStatusDashboardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const SubscriptionStatusInformationContainer = styled.div<{
  isSuccess: boolean
}>`
  padding: 10px 16px;
  background: ${({ isSuccess }) =>
    isSuccess ? 'rgba(35, 197, 20, 0.1)' : 'rgba(197, 41, 42, 0.1)'};
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  justify-content: center;

  > p {
    margin: 0;
  }

  ${CommonButton} {
    width: 100%;
  }

  @media ${theme.devices.tablet} {
    gap: 20px;
    justify-content: initial;
    padding: 12px 16px;

    ${CommonButton} {
      width: initial;
    }
  }
`

export const SubscriptionStatusInformationText = styled.p`
  ${Font14};
  flex: 1;
`

export const SubscriptionStatusButton = styled(CommonButton)`
  display: none;

  @media ${theme.devices.tablet} {
    display: initial;
  }
`
export const SubscriptionStatusHeaderButton = styled(CommonButton)`
  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const PurchaseStateCardSubtitleWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  width: 100%;
  margin-left: 21px;
`

export const PurchaseStateCardSubtitle = styled.span`
  ${Font14}
  text-align: left;
  font-weight: 600;
  color: ${theme.colors.moreGrey};
  display: flex;
  align-items: center;
  gap: 4px;
`

export const PurchaseClaimCardCountSubtitle = styled.span`
  font-size: 18px;
  color: ${theme.colors.otterWarmBlack};
  font-weight: bold;
`

export const PurchaseStateCardCountSubtitle = styled.span<{
  isSuccess: boolean
}>`
  font-size: 18px;
  color: ${({ isSuccess }) =>
    isSuccess ? theme.colors.success : theme.colors.error};
  font-weight: bold;
`

export const PurchaseSubscriptionContentBlock = styled.div`
  display: flex;
  gap: 8px;
  flex-flow: wrap row;

  @media ${theme.devices.mobile} {
    flex-direction: column;
    gap: ${theme.spacing.xs};
  }
`

export const PurchaseSubscriptionScrolledContentBlock = styled(
  PurchaseSubscriptionContentBlock
)`
  flex-flow: initial;
`

export const PurchaseSubscriptionBlockWrapper = styled.div<{
  disabled: boolean
}>`
  border-radius: 8px;
  padding: 16px;
  ${(p) =>
    p.disabled
      ? `background: ${theme.colors.lighterGrey};`
      : `border: 1px solid ${theme.colors.horizonOrange}; background-color: ${theme.colors.hover10};`}
  align-items: center;
  text-align: right;
  color: ${theme.colors.darkeyGrey};
  min-width: 200px;
  width: 100%;
  flex: 1;
  height: 180px;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;

  @media ${theme.devices.mobile} {
    ${(p) =>
      p.disabled
        ? `display:none;`
        : `border: 1px solid ${theme.colors.horizonOrange}; background-color: ${theme.colors.hover10};`}
  }

  > * {
    ${(p) => (p.disabled ? `color: ${theme.colors.lighterGrey};` : '')}
  }
`

export const PurchaseSubscriptionFinalBlockWrapper = styled(
  PurchaseSubscriptionBlockWrapper
)`
  width: 150px;
  min-height: 150px;
  ${(p) =>
    p.disabled
      ? `background: ${theme.colors.lighterGrey};`
      : `border: none; background-color: ${theme.colors.lighterGrey};`}
  height: auto;
`

export const PurchaseSubscritpionBlockItem = styled.div`
  display: flex;
  justify-content: space-between;
  width: 80%;
`

export const PurchaseSubscritpionItemTitle = styled.span`
  font-weight: 900;
  color: ${theme.colors.otterWarmBlack};
`

export const StyledPurchaseItemImg = styled.img`
  height: 40px;
  width: 40px;
`

export const PurchaseSubscritpionItemSubtitle = styled.span`
  ${Font14};
  color: ${theme.colors.darkeyGrey};
  width: 100%;
  text-align: right;
  font-weight: bold;
`

export const PurchaseSubscritpionFinalItemSubtitle = styled(
  PurchaseSubscritpionItemSubtitle
)`
  line-height: 50px;
`
